import boardTimelineActions from '../actions/boardTimelineActions';

const boardTimelineReducer = (state = {}, action) => {
  switch (action.type) {
    case boardTimelineActions.constants.set:
      return action.payload;

    default:
      return state;
  }
};

export default boardTimelineReducer;
